import styled from "styled-components"
import Modal from "./Modal"
import useDuplicateCheck from "shared/hooks/useDuplicateCheck"
import { useLocation } from "react-router-dom"

interface InputProps{
    type?:string
    label?:string,
    name?:string,
    value:string,
    required?:boolean,
    table:string,
    field:string,
    onChange:(event: React.ChangeEvent<HTMLInputElement>) => void
    setIsDuplicated:React.Dispatch<React.SetStateAction<any>> 
}


const InputWithDuplicateCheck = ({type, required, label, name, value, onChange, table, field, setIsDuplicated}:InputProps) =>{
    const {isOpenDuplicatedModal, setIsOpenDuplicatedModal, 
        isOpenCanUseModal, setIsOpenCanUseModal, 
        onDuplicateCheckClick, canUse} = useDuplicateCheck(table, {field:field, operator:"==", data:value}, setIsDuplicated);
    const id = useLocation().state;
    return(
        <Container >
            <Modal isOpen={isOpenDuplicatedModal} title="DUPLICATED" content="이미 사용중이거나 이전에 사용하였습니다" onClose={() => setIsOpenDuplicatedModal(false)}/>
            <Modal isOpen={isOpenCanUseModal} title="SUCCESS" content="사용 가능합니다" onClose={() => setIsOpenCanUseModal(false)}/>
            <Wrapper>
                <Label>{label}</Label>
                <DuplicateCheck onClick={onDuplicateCheckClick}>중복확인</DuplicateCheck>
            </Wrapper>
            <Input type={type} required={required} name={name} value={value} onChange={onChange} disabled={canUse || id}/>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
`
const Wrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`

const DuplicateCheck = styled.span`
    border-radius: 6px;
    border: 1px solid #DF0000;
    background: #FFFFFF;
    color: #DF0000;
    font-size: 12px;
    font-weight: 600;
    padding: 4px 8px;
    cursor: pointer;
`

const Label = styled.label`
    color: #0F172A;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
`
const Input = styled.input`
    height: 44px;
    padding-left: 12px;
    padding-right: 12px;
    border: 1px solid ${props => props.required ? "#DF0000" : "#E2E8F0"};
    border-radius: 8px;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    color: #0F172A;
    background: #FFFFFF;
    box-sizing: border-box;

    &:focus {
        outline: none;
        border-color: #DF0000;
        box-shadow: 0 0 0 3px rgba(223, 0, 0, 0.12);
    }

    &:disabled {
        background: #F1F5F9;
        color: #94A3B8;
        cursor: not-allowed;
    }
`




export default InputWithDuplicateCheck